import { render } from "./AuthModals.vue?vue&type=template&id=25d01d87"
import script from "./AuthModals.vue?vue&type=script&lang=js"
export * from "./AuthModals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__